import { Bot, X, LogOut, Users } from 'lucide-react';
import { getContrastColor } from '../../lib/colorUtils';

const ChatHeader = ({ 
  agent, 
  isTyping, 
  onClose, 
  onEndChat,
  primaryColor,
  title = "Online",
  chatState,
  showForm,
  showCloseButton = true 
}) => {

  const getStatusIndicator = () => {
    switch (chatState) {
      case 'handoff':
        return (
          <div className="flex mt-2 items-center gap-2 text-xs" style={{ color: getContrastColor(agent?.widget_settings?.secondary_color || '#E0E7FF') }}>
            <Users className="w-3 h-3" />
            <span>Aguardando atendimento...</span>
          </div>
        );
      case 'paused':
        return (
          <div className="flex mt-2 items-center gap-2 text-xs" style={{ color: getContrastColor(agent?.widget_settings?.secondary_color || '#E0E7FF') }}>
            <span>Falando com um atendente...</span>
          </div>
        );
      case 'ended':
        return (
          <div className="flex mt-2 items-center gap-2 text-xs" style={{ color: getContrastColor(agent?.widget_settings?.secondary_color || '#E0E7FF') }}>
            <span>Conversa encerrada.</span>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div 
      className="text-white p-4"
      style={{ 
        backgroundColor: primaryColor,
        backgroundImage: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor}dd 100%)`
      }}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center overflow-hidden">
            {agent?.widget_settings?.logo_url ? (
              <img 
                src={agent.widget_settings.logo_url} 
                alt={agent.name}
                className="w-full h-full object-cover"
              />
            ) : (
              <Bot className="w-7 h-7 text-white" />
            )}
          </div>
          <div>
            <h3 className="font-semibold">{agent?.name}</h3>
            <div className="flex items-center gap-2">
              {
                chatState !== "active" ? getStatusIndicator() : <>{isTyping ? (
                <span className="text-sm opacity-90">Digitando...</span>
              ) : (
                <span className="text-sm opacity-90">{title}</span>
              )}</>
              }
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
        {/* Botão de encerrar conversa - só mostra se chat está ativo */}
        {(chatState !== 'ended' && showForm !== true) && (
          <button
            onClick={onEndChat}
            className="p-2 hover:bg-white/20 rounded-lg transition-colors"
            title="Encerrar conversa"
          >
            <LogOut className="w-5 h-5" />
          </button>
        )}
        
        {/* Botão de fechar existente */}
        {showCloseButton && (
          <button
            onClick={onClose}
            className="p-2 hover:bg-white/20 rounded-lg transition-colors"
            title="Fechar chat"
          >
            <X className="w-5 h-5" />
          </button>
        )}
      </div>
      </div>
    </div>
  );
};

export default ChatHeader;